import React, { Component, PropTypes } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './actions';

import { NitroHeading, NitroModal, NitroText, NitroPanel, NitroContentNotAvailable } from 'nitro-components';

import WorkflowSetupGrid from './components/WorkflowSetupGrid';
import ApproverDetail from './components/ApproverDetail';
import { FilterGroup, CountryFilter, CostcenterFilter } from '../../components/filter';

import { setDefaultSource, getCountries } from '../../utils/helpers/costcenter';


import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import CorporateQuoteWorkflowSetupApi from '../../api/CorporateQuoteWorkflowSetupApi';
import Header from "../../components/layouts/Header";


const TABLE_ROW_LIMIT = 15;
let filters = [];

class WorkflowSetup extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      searchString: '',
      country: {},
      costcenter: {},
      sortQuery: '',
      currentPage: 0,
      approverDetailOpen: false,
      businessEntities: [],
      showModal: false
    };
  }

  componentDidMount() {
    console.log('componentDidMount');
    this.getList(null, null, null, 0);
  }

  getList = (countryObject, costCenterObject) => {
    let options = this.getOptions(countryObject, costCenterObject);
    if (options.countryCode != null && options.companyCode != null) {
      return this.props.actions.fetchWorkflowList(options);
    }
  };

  setSource = filters => {
    const country = filters[0];
    const costcenter = filters[1];
    const { setCountry, setCostcenter } = this.props.actions;
    setCountry(country);
    setCostcenter(costcenter);
    this.setState({
      currentPage: 0
    });
    this.getList(country, costcenter, 0);
  };

  fetchGridData = (currentPage, sortQuery) => {
    this.setState(
      {
        sortQuery: sortQuery,
        currentPage: currentPage
      },
      function() {
        this.getList(null, null, currentPage);
      }.bind(this)
    );
  };

  getOptions = (countryObject, costcenterObject, currentPage) => {
    let { country, costcenter } = this.props;

    country = countryObject || country;
    costcenter = costcenterObject || costcenter;

    let options = {
      countryCode: country.value,
      companyCode: costcenter.value
    };

    return options;
  };

  onApproverRowClick = row => {
    if (row.props.data.CanBeModified) {
      this.openApproverDetail(row.props.data);
    }
  };
  onNewApproverClick = () => {
    if (this.props.workflow) {
      this.openApproverDetail({ Level: 1, LevelOrder: 0, Docusign: false, User: null });
      this.closeModal();
    }
  };

  onNewWorkflowClick = copyFrom => {
    let { country, costcenter } = this.props;
    if (country && costcenter && country.value && costcenter.value) {
      let workflow = {
        EmployerCode: costcenter.value,
        CountryCode: country.value,
        Active: true,
        CopyApproversFromId: copyFrom
      };
      this.closeModal();
      CorporateQuoteWorkflowSetupApi.createNewWorkflow(workflow).then(data => {
        if (data.success) {
          this.getList().then(() => {
            this.closeModal();
            this.onNewApproverClick();
          });
        }
      });
    }
  };
  openApproverDetail = detailData => {
    console.log(detailData);
    this.props.actions.setSelectedApproverDetail(detailData);
    this.setState({
      approverDetailOpen: true
    });
  };

  closeApproverDetail = () => {
    this.props.actions.setSelectedApproverDetail(null);
    this.setState({
      approverDetailOpen: false
    });
  };
  loadBusinessEntities = () => {
    return this.props.actions.fetchBusinessEntities();
  };

  onApproverDetailFormChanged = values => {
    console.log('form chagned');
    console.log(values);
  };

  isApproverDetailValid = (approver, errors) => {
    if (approver.Docusign) {
      const workflowApprovers = this.props.workflow.WorkflowApprovers;
      workflowApprovers.forEach(item => {
        if (item.Docusign && item.Id !== approver.Id && item.Level === approver.Level) {
          errors.Docusign = `Docusign already assigned to ${item.User.FirstName} at level ${approver.Level}`;
        }
      });
    }
  };

  saveApproverDetail = approverDetail => {
    return CorporateQuoteWorkflowSetupApi.saveApproverDetail(approverDetail, this.props.workflow).then(data => {
      console.log(data);
      if (data.success) {
        this.getList();
      }
      return data;
    });
  };

  deleteApprover = approverDetail => {
    CorporateQuoteWorkflowSetupApi.deleteApproverDetail(approverDetail).then(data => {
      if (data.success) {
        this.getList();
      }
    });
  };

  showModal = () => {
    this.setState({
      showModal: true
    });
  };

  closeModal = () => {
    this.setState({
      showModal: false
    });
  };
  render() {
    const { country, costcenter, workflow } = this.props;
    const { showModal } = this.state;
    filters = [
      {
        title: 'Country',
        component: CountryFilter,
        ...country
      },
      {
        title: 'Cost Centre',
        component: CostcenterFilter,
        ...costcenter
      }
    ];
    const approvers = this.props.workflow != null ? this.props.workflow.WorkflowApprovers : [];

    let mainUI = null;
    if (workflow) {
      mainUI = (
        <NitroPanel padding="16px">
          <WorkflowSetupGrid
            data={approvers}
            total={approvers.length}
            getExternalData={this.fetchGridData}
            rowCount={TABLE_ROW_LIMIT}
            onRowClick={this.onApproverRowClick}
            currentPage={this.state.currentPage}
            dataFetching={this.props.fetchingData}
            deleteApprover={this.deleteApprover.bind(this)}
          />
          {
            <FloatingActionButton
              style={{ position: 'absolute', top: '0px', right: '20px' }}
              onTouchTap={
                workflow.CanBeModified
                  ? this.onNewApproverClick
                  : e => {
                      this.showModal();
                    }
              }>
              <ContentAdd />
            </FloatingActionButton>
          }
        </NitroPanel>
      );
    } else {
      mainUI = (
        <NitroPanel padding="16px">

          <NitroContentNotAvailable content=""  >
            <h3>
              No Workflow Setup Found . Click
            </h3>
            <FloatingActionButton onTouchTap={()=>{this.onNewWorkflowClick()}}>
                <ContentAdd />
              </FloatingActionButton>
              <h3>to create a new workflow</h3>
          </NitroContentNotAvailable>
        </NitroPanel>
      );
    }

    return (
      <section className="workflow-setup">
        <Header>

          <NitroHeading margin="10" label="Workflow Setup" size="1" variant="secondary" align="left" />

          <FilterGroup
            width="80%"
            action={this.setSource}
            title="Source"
            icon="source"
            filters={filters}
            align="right"
            disabled={false}
          />

        </Header>

        {mainUI}

        {this.props.selectedApproverDetail &&
          <ApproverDetail
            isOpen={this.state.approverDetailOpen}
            close={this.closeApproverDetail}
            initialValues={this.props.selectedApproverDetail}
            workflow={workflow}
            CountryCode={country.value}
            CompanyCode={costcenter.value}
            isFormValid={this.isApproverDetailValid.bind(this)}
            saveApproverDetail={this.saveApproverDetail.bind(this)}
          />}

        <NitroModal
          isOpen={showModal}
          title="Workflow Locked."
          actionLabel="Create New"
          action={() => this.onNewWorkflowClick(workflow.Id)}
          close={this.closeModal}
          variant="primary">

          <NitroText
            label={`Changes to this workflow has been locked due to the existing quotes which are already complete. Click "Create New" button to create a clone of the latest workflow`}
          />

        </NitroModal>

      </section>
    );
  }
}

WorkflowSetup.propTypes = {
  workflow: React.PropTypes.object,
  fetchingData: PropTypes.bool,
  country: PropTypes.object.isRequired,
  costcenter: PropTypes.object.isRequired,
  currentPage: PropTypes.number,
  sortQuery: PropTypes.string,
  approverDetailOpen: PropTypes.bool,
  selectedApproverDetail: PropTypes.object,
  actions: PropTypes.object
};

WorkflowSetup.contextTypes = {
  router: PropTypes.object
};

const mapStateToProps = state => {
  const { workflow, fetchingData, currentPage, sortQuery, selectedApproverDetail } = state.corporateQuoteWorkflowSetup;
  const { costcenter, country } = setDefaultSource(
    state.corporateQuoteWorkflowSetup.country,
    state.corporateQuoteWorkflowSetup.costcenter,
    getCountries(state.auth.config.filters)
  );

  return {
    fetchingData: fetchingData,
    country,
    costcenter,
    currentPage,
    sortQuery,
    workflow,
    selectedApproverDetail
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(WorkflowSetup);



// WEBPACK FOOTER //
// ./src/features/corporate-quote-workflow-setup/WorkflowSetup.js